// extracted by mini-css-extract-plugin
module.exports = {"blogCard":"featuredBlog-module--blogCard--IwcGa","blogCardImage":"featuredBlog-module--blogCardImage--2oizj","heading":"featuredBlog-module--heading--3G-4t"};